import * as z from "zod";

export const GradeCountSchema = z.object({
  grade: z.string(),
  count: z.number(),
});

export type GradeCount = z.infer<typeof GradeCountSchema>;

export const getReturnsItemsByGrade = {
  name: "getReturnsItemsByGrade" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    merchantTeamId: z.string().optional(),
  }),
  output: z.object({ grades: z.array(GradeCountSchema) }),
};
